module.exports = __webpack_public_path__ + "media/icons/raport@3x-311fb157.svg";